module.exports = __webpack_public_path__ + "static/rafiki-c4e00b24b70e37cb870e38985bbbaebd.svg";